import { GlobalResponseObject } from '@gtpl/shared-models/common-models'
import { AssetCheckListDto } from './check-list-dto';




export class CheckListtResponseModel extends GlobalResponseObject {
    data?: AssetCheckListDto[];
    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: AssetCheckListDto[]) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}
